import {
  FETCH_IMAGE_SLIDERS_LIST,
  FETCH_IMAGE_SLIDERS_LIST_ERROR,
  CLEAR_FETCH_IMAGE_SLIDERS_LIST,
  FETCH_IMAGE_SLIDER_DETAILS_SUCCESS,
  FETCH_IMAGE_SLIDER_DETAILS_ERROR,
  CLEAR_FETCH_IMAGE_SLIDER_DETAILS,
  APPLY_IMAGE_SLIDER_DRAG_SUCCESS,
  APPLY_IMAGE_SLIDER_DRAG_ERROR,
  CLEAR_IMAGE_SLIDER_DRAG,
  ADD_IMAGE_SLIDER_SUCCESS,
  ADD_IMAGE_SLIDER_ERROR,
  CLEAR_ADD_IMAGE_SLIDER,
  PATCH_IMAGE_SLIDER_SUCCESS,
  PATCH_IMAGE_SLIDER_ERROR,
  CLEAR_PATCH_IMAGE_SLIDER,
  DELETE_IMAGE_SLIDER_SUCCESS,
  DELETE_IMAGE_SLIDER_ERROR,
  CLEAR_DELETE_IMAGE_SLIDER,
  ADD_IMAGES_SUCCESS,
  ADD_IMAGES_ERROR,
  CLEAR_ADD_IMAGES,
  DELETE_IMAGES_SUCCESS,
  DELETE_IMAGES_ERROR,
  CLEAR_DELETE_IMAGES,
  VERIFY_INSTAGRAM_ACCOUNT_SUCCESS,
  VERIFY_INSTAGRAM_ACCOUNT_ERROR,
  CLEAR_VERIFY_INSTAGRAM_ACCOUNT,
  PATCH_DETAILS_FOR_IMAGE_SLIDER_SUCCESS,
  PATCH_DETAILS_FOR_IMAGE_SLIDER_ERROR,
  CLEAR_PATCH_DETAILS_FOR_IMAGE_SLIDER,
} from 'redux/image-sliders/types';

const initialState = {
  imageSlidersList: null,
  imageSlidersListError: null,
  imageSliderDetails: null,
  imageSliderDetailsError: null,
  dragImageSliderSuccess: null,
  dragImageSliderError: null,
  addImageSliderSuccess: null,
  addImageSliderError: null,
  patchImageSliderSuccess: null,
  patchImageSliderError: null,
  deleteImageSliderSuccess: null,
  deleteImageSliderError: null,
  addImagesSuccess: null,
  addImagesError: null,
  deleteImagesSuccess: null,
  deleteImagesError: null,
  verifyInstagramAccountSuccess: null,
  verifyInstagramAccountError: null,
  patchDetailsForImageSliderSuccess: null,
  patchDetailsForImageSliderError: null,
};


export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_IMAGE_SLIDERS_LIST:
      return {
        ...state,
        imageSlidersList: action.payload.data,
        imageSlidersListError: null,
      };
    case FETCH_IMAGE_SLIDERS_LIST_ERROR:
      return {
        ...state,
        imageSlidersList: null,
        imageSlidersListError: action.payload.data,
      };
    case CLEAR_FETCH_IMAGE_SLIDERS_LIST:
      return {
        ...state,
        imageSlidersList: null,
        imageSlidersListError: null,
      };
    case FETCH_IMAGE_SLIDER_DETAILS_SUCCESS:
      return {
        ...state,
        imageSliderDetails: action.payload.data,
        imageSliderDetailsError: null,
      };
    case FETCH_IMAGE_SLIDER_DETAILS_ERROR:
      return {
        ...state,
        imageSliderDetails: null,
        imageSliderDetailsError: action.payload.data,
      };
    case CLEAR_FETCH_IMAGE_SLIDER_DETAILS:
      return {
        ...state,
        imageSliderDetails: null,
        imageSliderDetailsError: null,
      };
    case APPLY_IMAGE_SLIDER_DRAG_SUCCESS:
      return {
        ...state,
        dragImageSliderSuccess: action.payload.data,
        dragImageSliderError: null,
      };
    case APPLY_IMAGE_SLIDER_DRAG_ERROR:
      return {
        ...state,
        dragImageSliderSuccess: null,
        dragImageSliderError: action.payload.data,
      };
    case CLEAR_IMAGE_SLIDER_DRAG:
      return {
        ...state,
        dragImageSliderSuccess: null,
        dragImageSliderError: null,
      };
    case ADD_IMAGE_SLIDER_SUCCESS:
      return {
        ...state,
        addImageSliderSuccess: action.payload.data,
        addImageSliderError: null,
      };
    case ADD_IMAGE_SLIDER_ERROR:
      return {
        ...state,
        addImageSliderSuccess: null,
        addImageSliderError: action.payload.data,
      };
    case CLEAR_ADD_IMAGE_SLIDER:
      return {
        ...state,
        addImageSliderSuccess: null,
        addImageSliderError: null,
      };
    case PATCH_IMAGE_SLIDER_SUCCESS:
      return {
        ...state,
        patchImageSliderSuccess: action.payload.data,
        patchImageSliderError: null,
      };
    case PATCH_IMAGE_SLIDER_ERROR:
      return {
        ...state,
        patchImageSliderSuccess: null,
        patchImageSliderError: action.payload.data,
      };
    case CLEAR_PATCH_IMAGE_SLIDER:
      return {
        ...state,
        patchImageSliderSuccess: null,
        patchImageSliderError: null,
      };
    case DELETE_IMAGE_SLIDER_SUCCESS:
      return {
        ...state,
        deleteImageSliderSuccess: action.payload.data,
        deleteImageSliderError: null,
      };
    case DELETE_IMAGE_SLIDER_ERROR:
      return {
        ...state,
        deleteImageSliderSuccess: null,
        deleteImageSliderError: action.payload.data,
      };
    case CLEAR_DELETE_IMAGE_SLIDER:
      return {
        ...state,
        deleteImageSliderSuccess: null,
        deleteImageSliderError: null,
      };
    case ADD_IMAGES_SUCCESS:
      return {
        ...state,
        addImagesSuccess: action.payload.data,
        addImagesError: null,
      };
    case ADD_IMAGES_ERROR:
      return {
        ...state,
        addImagesSuccess: null,
        addImagesError: action.payload.data,
      };
    case CLEAR_ADD_IMAGES:
      return {
        ...state,
        addImagesSuccess: null,
        addImagesError: null,
      };
    case DELETE_IMAGES_SUCCESS:
      return {
        ...state,
        deleteImagesSuccess: action.payload.data,
        deleteImagesError: null,
      };
    case DELETE_IMAGES_ERROR:
      return {
        ...state,
        deleteImagesSuccess: null,
        deleteImagesError: action.payload.data,
      };
    case CLEAR_DELETE_IMAGES:
      return {
        ...state,
        deleteImagesSuccess: null,
        deleteImagesError: null,
      };
    case VERIFY_INSTAGRAM_ACCOUNT_SUCCESS:
      return {
        ...state,
        verifyInstagramAccountSuccess: action.payload.data,
        verifyInstagramAccountError: null,
      };
    case VERIFY_INSTAGRAM_ACCOUNT_ERROR:
      return {
        ...state,
        verifyInstagramAccountSuccess: null,
        verifyInstagramAccountError: action.payload.data,
      };
    case CLEAR_VERIFY_INSTAGRAM_ACCOUNT:
      return {
        ...state,
        verifyInstagramAccountSuccess: null,
        verifyInstagramAccountError: null,
      };
    case PATCH_DETAILS_FOR_IMAGE_SLIDER_SUCCESS:
      return {
        ...state,
        patchDetailsForImageSliderSuccess: action.payload.data,
        patchDetailsForImageSliderError: null,
      };
    case PATCH_DETAILS_FOR_IMAGE_SLIDER_ERROR:
      return {
        ...state,
        patchDetailsForImageSliderSuccess: null,
        patchDetailsForImageSliderError: action.payload.data,
      };
    case CLEAR_PATCH_DETAILS_FOR_IMAGE_SLIDER:
      return {
        ...state,
        patchDetailsForImageSliderSuccess: null,
        patchDetailsForImageSliderError: null,
      };
    default:
      return state;
  }
};
